import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { ApiContent } from "admin/pages/home/shaping";
const VisionSwiper = React.lazy(() => import('./vision_swiper'));

interface GoalsData {
  image: string;
  title: string;
}

const Vision = React.memo(() => {
  const [apiData, setApiData] = useState<GoalsData[]>([]);
  const [apiContent, setApiContent] = useState<ApiContent | null>(null);

 
  const staticData = useMemo(
    () => [
      {
        logo: "/Home/vision/logo-1.png",
        title: "Vision",
        desc: "Shaping a progressive, inclusive India and the world, through entrepreneurial change-makers.",
      },
      {
        logo: "/Home/vision/logo-2.png",
        title: "Mission",
        desc: "Bring diverse stakeholders onto a single platform for nurturing ecosystems that add value for the greater good.",
      },
      {
        logo: "/Home/vision/logo-3.png",
        title: "Purpose",
        desc: "Build an institution of compassion and enlightenment that attracts enterprising men and women who are passionate about scripting social transformation.",
      },
    ],
    []
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [goalsRes, contentRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_LOCAL_URL}/api/goal`),
          axios.get(`${process.env.REACT_APP_LOCAL_URL}/api/content/68efcc0e2d25c3fab3031989`),
        ]);

        if (goalsRes.data.status === "success") setApiData(goalsRes.data.message || []);
        if (contentRes.data.status === "success") setApiContent(contentRes.data.data || null);
      } catch (error) {
        console.error("Error fetching vision data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <section className="gsap-fade-in blade-top-padding-lg bg-[#FFFBEF]">
      <section className="w-container">
        <h1 className="font-lato-bold text-[#07393C]">Vision and Mission</h1>
        <div className="w-full h-[1px] bg-[#84848480] mt-2" />

        <VisionSwiper />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7 xl:gap-14 mt-5">
          {staticData.map((elem, index) => (
            <div
              key={elem.title}
              className={`flex flex-col gap-5 blade-top-padding-sm ${
                index === 2
                  ? "border-r border-transparent"
                  : "md:border-r md:border-[#84848480] md:px-4"
              }`}
            >
              <h3 className="font-lato-bold text-[#07393C]">{elem.title}</h3>
              <h4
                className="font-lato-regular"
                dangerouslySetInnerHTML={{ __html: elem.desc }}
              />
            </div>
          ))}
        </div>

        <div className="pt-5 md:blade-top-margin-sm blade-bottom-padding-lg">
          <h3 className="2xl:text-4xl font-lato-bold text-[#07393C]">
            {apiContent?.heading}
          </h3>
          <div className="sm:blade-top-margin-sm blade-top-margin grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-14 !w-full">
            {apiData.map((elem, index) => {
              const imgSrc = `${process.env.REACT_APP_LOCAL_URL}/${elem.image.replace(/\\/g, "/")}`;
              return (
                <div
                  key={elem.title + index} // unique key
                  className="flex items-center gap-5 w-full sm:w-3/4 lg:w-full"
                >
                  <div className="shrink-0">
                    <img src={imgSrc} alt={elem.title || "goal"} loading="lazy" />
                  </div>
                  <h4
                    className="font-lato-regular"
                    dangerouslySetInnerHTML={{ __html: elem.title }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </section>
  );
});

export default Vision;
